import React from "react";
import type { ClauseInfo } from "./ReviewResponseModel.types";

interface ClauseInfoPopupProps {
  clauseInfo: ClauseInfo;
  onClose: () => void;
}

const ClauseInfoPopup: React.FC<ClauseInfoPopupProps> = ({
  clauseInfo,
  onClose,
}) => {
  return (
    <div
      className="review-popup-overlay"
      onClick={onClose}
      onKeyDown={(e) => {
        if (e.key === "Enter" || e.key === " ") {
          onClose();
        }
      }}
      role="button"
      tabIndex={0}
    >
      <div
        className="review-popup-container review-clause-info-popup"
        onClick={(e) => e.stopPropagation()}
        onKeyDown={(e) => e.stopPropagation()}
        role="dialog"
      >
        <div className="review-popup-header">
          <h3>Question Information</h3>
          <button className="review-popup-close-button" onClick={onClose}>
            <svg
              width="20"
              height="20"
              viewBox="0 0 20 20"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
            >
              <path d="M15 5L5 15M5 5l10 10" />
            </svg>
          </button>
        </div>

        <div className="review-popup-content">
          <div className="review-clause-detail">
            <span className="review-detail-label">Clause ID:</span>
            <span className="review-detail-value">{clauseInfo.clauseId}</span>
          </div>

          <div className="review-clause-detail">
            <span className="review-detail-label">Description:</span>
            <p className="review-detail-text">{clauseInfo.description}</p>
          </div>

          <div className="review-clause-detail">
            <span className="review-detail-label">Purpose:</span>
            <p className="review-detail-text">{clauseInfo.purpose}</p>
          </div>

          {clauseInfo.artifacts && clauseInfo.artifacts.length > 0 && (
            <div className="review-clause-detail">
              <span className="review-detail-label">Artifacts:</span>
              <ul className="review-artifacts-list">
                {clauseInfo.artifacts.map((artifact, index) => (
                  <li key={index} className="review-artifact-list-item">
                    {artifact}
                  </li>
                ))}
              </ul>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default ClauseInfoPopup;
